import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const Assignment24pxIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2H11.82C11.4 0.84 10.3 0 9 0C7.7 0 6.6 0.84 6.18 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM9 2C9.55 2 10 2.45 10 3C10 3.55 9.55 4 9 4C8.45 4 8 3.55 8 3C8 2.45 8.45 2 9 2ZM5 16H10C10.55 16 11 15.55 11 15C11 14.45 10.55 14 10 14H5C4.45 14 4 14.45 4 15C4 15.55 4.45 16 5 16ZM13 12H5C4.45 12 4 11.55 4 11C4 10.45 4.45 10 5 10H13C13.55 10 14 10.45 14 11C14 11.55 13.55 12 13 12ZM5 8H13C13.55 8 14 7.55 14 7C14 6.45 13.55 6 13 6H5C4.45 6 4 6.45 4 7C4 7.55 4.45 8 5 8Z"
        fill={color}
      />
    </IconBase>
  );
};

export default Assignment24pxIcon;
